define('formkit/behavior/design.single.form.object.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');

  var EVENT_SEPARATOR = ' ';

  var DesignSingleFormObjectBehavior = Mn.Behavior.extend({

    defaults: {
      form: null,
      changeDesigningEvents: 'formObject:change:designing'
    },

    initialize: function() {
      this.listenToOnce(this.view, 'before:render', function() {
        this.setupTemplateObjectListeners();
      })
    },

    setupTemplateObjectListeners: function() {
      var changeDesigningEvents = this.getOption('changeDesigningEvents').split(EVENT_SEPARATOR);
      _.each(changeDesigningEvents, function(event, param) {
        var form = this.getOption('form');
        if (!form) {
          form = this.view.form;
        }

        if (form) {
          this.listenTo(form, event, this.onChangeDesigning);
        }
      }, this);
    },

    onChangeDesigning: function(formObject) {
      if(this.formObjectCurrentlyDesigning != formObject && formObject.designing) {
        if (this.formObjectCurrentlyDesigning) {
          this.formObjectCurrentlyDesigning.designing = false;
        }
        this.formObjectCurrentlyDesigning = formObject;
      }
    }
  });

  module.exports = DesignSingleFormObjectBehavior;
});

